// src/data/exercises/R1_exercises.js

/* =========================================================
   R1_01：給料の支払（源泉徴収あり）
   ========================================================= */

const accountOptions_R1_01 = [
  '現金',
  '普通預金',
  '当座預金',
  '所得税預り金',
  '給料',
];

export const R1_01 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '従業員への給料￥1,200,000の支払に際して、所得税の源泉徴収額￥156,000を差し引き、普通預金口座から口座振込で支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_01,
      },

      answer: [
        {
          debitAccount: '給料',
          debitAmount: 1200000,
          creditAccount: '所得税預り金',
          creditAmount: 156000,
        },
        {
          debitAccount: null,
          debitAmount: null,
          creditAccount: '普通預金',
          creditAmount: 1044000,
        },
      ],
    },
  ],
};

/* =========================================================
   R1_02：会社設立時の払込（資本金）
   ========================================================= */

const accountOptions_R1_02 = [
  '現金',
  '普通預金',
  '有価証券',
  '資本金',
];

export const R1_02 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q2',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '株式会社設立に際し、株式2,500株を＠￥1,300で発行し、全額は普通預金口座に払い込まれた。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_02,
      },

      answer: [
        {
          debitAccount: '普通預金',
          debitAmount: 3250000,
          creditAccount: '資本金',
          creditAmount: 3250000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_03：会社設立時の払込（資本金）
   ========================================================= */

const accountOptions_R1_03 = [
  '現金',
  '当座預金',
  '有価証券',
  '資本金',
];

export const R1_03 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q3',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '札幌商事株式会社は、その設立にあたり、定款で定める発行可能株式総数16,000株のうち、4,000株を1株につき￥2,850で発行し、全額の当座払い込みを受けた。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_03,
      },

      answer: [
        {
          debitAccount: '当座預金',
          debitAmount: 11400000,
          creditAccount: '資本金',
          creditAmount: 11400000,
        },
      ],
    },
  ],
};

/* =========================================================
   R1_04：普通預金から定期預金への振替
   ========================================================= */

const accountOptions_R1_04 = [
  '普通預金',
  '定期預金',
];

export const R1_04 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q4',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '普通預金口座から￥5,000,000を定期預金口座へ振り替えた。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_04,
      },

      answer: [
        {
          debitAccount: '定期預金',
          debitAmount: 5000000,
          creditAccount: '普通預金',
          creditAmount: 5000000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_05：従業員の立替金（会社が立替え）
   ========================================================= */

const accountOptions_R1_05 = [
  '現金',
  '当座預金',
  '仕入',
  '立替金',
];

export const R1_05 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q5',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '山梨株式会社は，従業員個人が負担すべき物品の購入代金￥290,000を立て替えて，現金で支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_05,
      },

      answer: [
        {
          debitAccount: '立替金',
          debitAmount: 290000,
          creditAccount: '現金',
          creditAmount: 290000,
        },
      ],
    },
  ],
};

/* =========================================================
   R1_06：従業員立替金の精算
   ========================================================= */

const accountOptions_R1_06 = [
  '有価証券',
  '繰越利益剰余金',
  '有価証券売却益',
  '損益',
];

export const R1_06 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q6',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '株式会社四国商会の当期決算において、当期純利益が￥3,800,000と算定された。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_06,
      },

      answer: [
        {
          debitAccount: '損益',
          debitAmount: 3800000,
          creditAccount: '繰越利益剰余金',
          creditAmount: 3800000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_07：掛けによる商品仕入
   ========================================================= */

const accountOptions_R1_07 = [
  '有価証券',
  '繰越利益剰余金',
  '有価証券売却益',
  '損益',
];

export const R1_07 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q7',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '株式会社四国商会の当期決算において、当期純損失が￥3,800,000と算定された。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_07,
      },

      answer: [
        {
          debitAccount: '繰越利益剰余金',
          debitAmount: 3800000,
          creditAccount: '損益',
          creditAmount: 3800000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_08：買掛金の支払（現金）
   ========================================================= */

const accountOptions_R1_08 = [
  '普通預金',
  '有価証券',
  '繰越利益剰余金',
'租税公課',
];

export const R1_08 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q8',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '固定資産税￥340,000が普通預金口座より引き落とされた。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_08,
      },

      answer: [
        {
          debitAccount: '租税公課',
          debitAmount: 340000,
          creditAccount: '普通預金',
          creditAmount: 340000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_09：掛けによる商品販売
   ========================================================= */

const accountOptions_R1_09 = [
  '現金',
  '有価証券',
  '通信費',
  '租税公課',
];

export const R1_09 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q9',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '郵便局で収入印紙￥10,000を購入し，代金は現金で支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_09,
      },

      answer: [
        {
          debitAccount: '租税公課',
          debitAmount: 10000,
          creditAccount: '現金',
          creditAmount: 10000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_10：売掛金の回収（普通預金）
   ========================================================= */

const accountOptions_R1_10 = [
  '現金',
  '普通預金',
  '未払金',
  '備品',
];

export const R1_10 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q10',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '事務用コンピュータ￥1,000,000を購入し、その代金は配送料・据付費などの諸費用￥100,000とともに、代金は後日振り込むこととなった。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_10,
      },

      answer: [
        {
          debitAccount: '備品',
          debitAmount: 1100000,
          creditAccount: '未払金',
          creditAmount:1100000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_11：事務用品の現金購入
   ========================================================= */

const accountOptions_R1_11 = [
  '現金',
  '建物',
  '備品',
  '未払金',
];

export const R1_11 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q11',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '建物￥7,000,000を購入し，代金は月末に支払うこととした。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_11,
      },

      answer: [
        {
          debitAccount: '建物',
          debitAmount: 7000000,
          creditAccount: '未払金',
          creditAmount: 7000000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_12：家賃の前払い
   ========================================================= */

const accountOptions_R1_12 = [
  '現金',
  '当座預金',
  '未払金',
  '車両運搬具',
];

export const R1_12 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q12',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '商品運搬用のトラックを￥2,000,000で購入し、その代金は納車費用などの諸費用￥100,000とともに小切手を振り出して支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_12,
      },

      answer: [
        {
          debitAccount: '車両運搬具',
          debitAmount: 2100000,
          creditAccount: '当座預金',
          creditAmount: 2100000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_13：前払家賃の振替
   ========================================================= */

const accountOptions_R1_13 = [
  '現金',
  '貸付金',
'借入金',
'支払手形',
'受取手形',
];

export const R1_13 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q13',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '多摩商事株式会社に現金￥1,000,000を貸し付け、借用証書を受け取った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_13,
      },

      answer: [
        {
          debitAccount: '貸付金',
          debitAmount: 1000000,
          creditAccount: '現金',
          creditAmount: 1000000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_14：備品の現金購入
   ========================================================= */

const accountOptions_R1_14 = [
  '現金',
  '貸付金',
  '借入金',
  '支払手形',
'受取手形',
];

export const R1_14 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q14',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '多摩商事株式会社から現金￥1,000,000を借り入れ、借用証書を渡した。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_14,
      },

      answer: [
        {
          debitAccount: '現金',
          debitAmount: 1000000,
          creditAccount: '借入金',
          creditAmount: 1000000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_15：備品の減価償却
   ========================================================= */

const accountOptions_R1_15 = [
  '売掛金',
  '買掛金',
  '売上',
  '仕入',
];

export const R1_15 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q15',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              'かねて九州商事株式会社に掛けで販売していた商品￥900,000のうち￥10,000が品違いのため返品されてきた。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_15,
      },

      answer: [
        {
          debitAccount: '売上',
          debitAmount: 10000,
          creditAccount: '売掛金',
          creditAmount: 10000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_16：借入金の受け入れ（普通預金）
   ========================================================= */

const accountOptions_R1_16 = [
  '売掛金',
  '買掛金',
  '売上',
'仕入',
];

export const R1_16 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q16',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              'かねて九州商事株式会社より掛けで仕入れていた商品￥900,000のうち￥10,000を品違いのため返品した。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_16,
      },

      answer: [
        {
          debitAccount: '買掛金',
          debitAmount: 10000,
          creditAccount: '仕入',
          creditAmount: 10000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_17：利息の支払
   ========================================================= */

const accountOptions_R1_17 = [
  '売掛金',
  '貸倒損失',
  '貸倒引当金',
  
];

export const R1_17 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q17',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '当期に生じた渡瀬産業株式会社に対する売掛金￥100,000が回収不能となり、全額貸倒処理を行った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_17,
      },

      answer: [
        {
          debitAccount: '貸倒損失',
          debitAmount: 100000,
          creditAccount: '売掛金',
          creditAmount: 100000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_18：追加出資の受入
   ========================================================= */

const accountOptions_R1_18 = [
  '売掛金',
  '貸倒損失',
  '貸倒引当金',
];

export const R1_18 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q18',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '前期に生じた渡瀬産業株式会社に対する売掛金￥100,000が回収不能となり、全額貸倒引当金を充当した。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_18,
      },

      answer: [
        {
          debitAccount: '貸倒引当金',
          debitAmount: 100000,
          creditAccount: '売掛金',
          creditAmount: 100000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_19：水道光熱費の支払（普通預金）
   ========================================================= */

const accountOptions_R1_19 = [
  '現金',
  '普通預金',
  '有価証券',
'資本金',

];

export const R1_19 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q19',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '河内産業株式会社の株式500株を1株につき￥7,290で購入し、その代金は証券会社に対する購入手数料￥6,600とともに当社の普通預金口座から支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_19,
      },

      answer: [
        {
          debitAccount: '有価証券',
          debitAmount: 3651600,
          creditAccount: '普通預金',
          creditAmount: 3651600,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_20：保険料の前払い
   ========================================================= */

const accountOptions_R1_20 = [
  '現金',
  '当座預金',
  '資本金',
  '有価証券',
];

export const R1_20 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q20',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '愛知商事株式会社発行の額面￥3,000,000の社債を額面￥100につき￥97で購入し，代金は小切手を振り出して支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_20,
      },

      answer: [
        {
          debitAccount: '有価証券',
          debitAmount: 2910000,
          creditAccount: '当座預金',
          creditAmount: 2910000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_21：受取利息の発生
   ========================================================= */

const accountOptions_R1_21 = [
  '現金',
  '未収金',
  '有価証券',
  '未払金',
  '有価証券売却益',
  '有価証券売却損',
];

export const R1_21 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q21',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '保有している北陸産業株式会社の株式300株（帳簿価額＠￥16,000）を＠￥20,500で全株売却し、代金は後日振り込まれることとなった。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_21,
      },

      answer: [
        {
          debitAccount: '未収金',
          debitAmount: 6150000,
          creditAccount: '有価証券',
          creditAmount: 4800000,
        },
        {
          debitAccount: null,
          debitAmount: null,
          creditAccount: '有価証券売却益',
          creditAmount: 1350000,
        },
      ],

    },
  ],
};


/* =========================================================
   R1_22：広告宣伝費の支払
   ========================================================= */

const accountOptions_R1_22 = [
  '現金',
  '売掛金',
  '前払金',
'仮払消費税',
'買掛金',
'前受金',
'仮受消費税',
'仕入',

];

export const R1_22 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q22',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '東北産業株式会社よりA商品￥3,531,000（うち消費税額￥321,000）を仕入れ、代金のうち￥500,000は以前支払っていた内金を充当し、残額は掛けとした。なお、消費税を税抜き方式で処理する。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_22,
      },

      answer: [
        {
          debitAccount: '仕入',
          debitAmount: 3210000,
          creditAccount: '前払金',
          creditAmount: 500000,
        },
        {
          debitAccount: '仮払消費税',
          debitAmount: 321000,
          creditAccount: '買掛金',
          creditAmount: 3031000,
        },
      ],

    },
  ],
};


/* =========================================================
   R1_23：事業主の私的引出し
   ========================================================= */

const accountOptions_R1_23 = [
  '現金',
  '受取手形',
  '前払金（支払手付金）',
'仮払消費税',
'支払手形',
'前受金',
'仮受消費税',
'売上',
];

export const R1_23 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q23',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '株式会社貴崎商事へ商品￥3,850,000（うち消費税￥350,000）を販売し、代金のうち￥600,000は以前受け取っていた手付金を充当し、残額は株式会社貴崎商事振り出しの小切手を受け取った。なお、消費税を税抜き方式で処理する。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_23,
      },

     answer: [
        {
          debitAccount: '前受金',
          debitAmount: 600000,
          creditAccount: '売上',
          creditAmount: 3500000,
        },
        {
          debitAccount: '現金',
          debitAmount: 3250000,
          creditAccount: '仮受消費税',
          creditAmount: 350000,
        },
      ],

    },
  ],
};


/* =========================================================
   R1_24：事業主による資産の持ち込み
   ========================================================= */

const accountOptions_R1_24 = [
  '普通預金',
  '定期預金',
  '受取利息',
    '支払利息',
];

export const R1_24 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q24',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '本日、定期預金￥2,000,000が満期となり、定期預金口座から￥2,000,000とほかに満期利息額￥500が普通預金口座に振り替えられた。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_24,
      },

      answer: [
        {
          debitAccount: '普通預金',
          debitAmount: 2000500,
          creditAccount: '定期預金',
          creditAmount: 2000000,
        },
        {
          debitAccount: null,
          debitAmount: null,
          creditAccount: '受取利息',
          creditAmount: 500,
        },
      ],

    },
  ],
};


/* =========================================================
   R1_25：未払費用（給料）の計上
   ========================================================= */

const accountOptions_R1_25 = [
  '現金',
  '当座預金',
  '売掛金',
 '商品',
 '売上',
 '売上原価',
];

export const R1_25 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q25',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '株式会社宇都宮商事に商品250個（原価￥＠1,200、売価＠￥2,100）を販売し、代金のうち￥100,000は株式会社宇都宮商事振り出しの小切手で受け取り、残額は掛けとした。だたし、商品売買に関して、販売のつど売上原価勘定に振り替える方法で記帳している。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_25,
      },

      answer: [
        {
          debitAccount: '現金',
          debitAmount: 100000,
          creditAccount: '売上',
          creditAmount:525000,
        },
        {
          debitAccount: '売掛金',
          debitAmount: 425000,
          creditAccount: '商品',
          creditAmount: 300000,
        },
               {
          debitAccount: '売上原価',
          debitAmount: 300000,
          creditAccount: null,
          creditAmount: null,
        },

      ],


    },
  ],
};


/* =========================================================
   R1_26：未払費用（給料）の支払
   ========================================================= */

const accountOptions_R1_26 = [
  '商品',
  '買掛金',
  '売上原価',
    '売上',
];

export const R1_26 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q26',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '株式会社新潟商店から掛けで仕入れていた商品に品違いがあったため，商品￥3,000を返品し，掛代金と相殺した。ただし，当社は，商品販売取引に関して，販売のつど，売上原価勘定に振り替える方法（売上原価対立法）で記帳している。',},
        ],
      },
      table: {
        options: accountOptions_R1_26,
      },

      answer: [
        {
          debitAccount: '買掛金',
          debitAmount: 3000,
          creditAccount: '商品',
          creditAmount: 3000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_27：支払手形の振り出しによる仕入
   ========================================================= */

const accountOptions_R1_27 = [
  '現金',
  '当座預金',
  '仮払金',
   '旅費交通費',
];

export const R1_27 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q27',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '従業員の出張に際して、旅費の概算額￥50,000を現金で支払った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_27,
      },

      answer: [
        {
          debitAccount: '仮払金',
          debitAmount: 50000,
          creditAccount: '現金',
          creditAmount: 50000,
        },
      ],
    },
  ],
};


/* =========================================================
   R1_28：受取手形による売上
   ========================================================= */

const accountOptions_R1_28 = [
  '現金',
  '当座預金',
  '仮払金',
    '旅費交通費',
];

export const R1_28 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q28',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              'かねて従業員の出張に際して、旅費の概算額として現金￥200,000を渡していたが、本日、従業員が帰社し、旅費として、￥180,000支払った旨の報告を受け、残額を現金で受け取った。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_28,
      },

      answer: [
        {
          debitAccount: '旅費交通費',
          debitAmount: 180000,
          creditAccount: '仮払金',
          creditAmount: 200000,
        },
        {
          debitAccount: '現金',
          debitAmount: 20000,
          creditAccount: null,
          creditAmount: null,
        },
      ],

    },
  ],
};


/* =========================================================
   R1_29：受取手形の取立て（普通預金）
   ========================================================= */

const accountOptions_R1_29 = [
  '当座預金',
  '現金',
  '支払利息',
'受取利息',
'貸付金',
];

export const R1_29 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q29',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '千葉商事株式会社へ￥3,000,000（貸付期間２年，利率年４％）を貸付け，向こう１年分の利息を差し引いた残額の小切手を振り出した。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_29,
      },

      answer: [
        {
          debitAccount: '貸付金',
          debitAmount: 3000000,
          creditAccount: '受取利息',
          creditAmount: 120000,
        },
        {
          debitAccount: null,
          debitAmount: null,
          creditAccount: '当座預金',
          creditAmount: 2880000,
        },
      ],

    },
  ],
};


/* =========================================================
   R1_30：受取手形の取立て（普通預金）
   ========================================================= */

const accountOptions_R1_30 = [
  '現金',
  '未収金',
  '有価証券',
'未払金',
'有価証券売却益',
'有価証券売却損',

];

export const R1_30 = {
  title: '簿記　3級（仕分練習）',
  questions: [
    {
      id: 'q30',
      type: 'JOURNAL_ENTRY',
      content: {
        parts: [
          {
            type: 'text',
            value:
              '保有している北陸産業株式会社の株式300株（帳簿価額＠￥20,500）を＠￥16,000で全株売却し、代金は後日振り込まれることとなった。',
          },
        ],
      },
      table: {
        options: accountOptions_R1_30,
      },

      answer: [
        {
          debitAccount: '未収金',
          debitAmount: 4800000,
          creditAccount: '有価証券',
          creditAmount: 6150000,
        },
        {
          debitAccount: '有価証券売却損',
          debitAmount: 1350000,
          creditAccount: null,
          creditAmount: null,
        },
      ],

    },
  ],
};




/* =========================================================
   Gộp mapping cho cả nhóm R1-* để dùng trong allExercises
   ========================================================= */

export const R1_EXERCISES = {
  'R1-01': R1_01,
  'R1-02': R1_02,
  'R1-03': R1_03,
  'R1-04': R1_04,
  'R1-05': R1_05,
  'R1-06': R1_06,
  'R1-07': R1_07,
  'R1-08': R1_08,
  'R1-09': R1_09,
  'R1-10': R1_10,

  'R1-11': R1_11,
  'R1-12': R1_12,
  'R1-13': R1_13,
  'R1-14': R1_14,
  'R1-15': R1_15,
  'R1-16': R1_16,
  'R1-17': R1_17,
  'R1-18': R1_18,
  'R1-19': R1_19,
  'R1-20': R1_20,

  'R1-21': R1_21,
  'R1-22': R1_22,
  'R1-23': R1_23,
  'R1-24': R1_24,
  'R1-25': R1_25,
  'R1-26': R1_26,
  'R1-27': R1_27,
  'R1-28': R1_28,
  'R1-29': R1_29,
'R1-30': R1_30,
};
